import { Button } from "@/components/ui/button";

interface AbrirChamadoCardProps {
  title?: string;
  buttonLabel?: string;
  onClick?: () => void;
}

export default function AbrirChamadoCard({
  title = "Abrir novo chamado",
  buttonLabel = "Iniciar",
  onClick,
}: AbrirChamadoCardProps) {
  return (
    <div className="bg-white rounded-[20px] py-4 px-6 flex items-center justify-between">
      <span className="text-lg font-semibold text-n-green">{title}</span>

      <Button variant="green" type="button" size="sm" onClick={onClick}>
        {buttonLabel}
      </Button>
    </div>
  );
}
